<script setup lang="ts">
import Checkbox from '@/components/Forms/Checkbox.vue'
import { useAlarmStore } from '@/store/alarm'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const alarmStore = useAlarmStore()
const { lastSearchAlarmScope } = storeToRefs(alarmStore)
const { setLastSearchAlarmScope } = alarmStore

const selectedScope = computed({
  get: () => lastSearchAlarmScope.value,
  set: (value: 'individual' | 'group') => {
    setLastSearchAlarmScope(value)
  },
})
</script>

<template>
  <div class="mb-4 min-w-0 w-full">
    <div class="flex flex-wrap items-center gap-4 pb-4">
      <h1 class="text-title-md2 font-semibold text-black">
        {{ t('alarm_listing.header.title') }}
      </h1>
      <div class="flex flex-wrap items-center gap-4">
        <Checkbox
          :label-text="t('alarm_listing.panel.scope_individual')"
          value="individual"
          v-model="selectedScope" />
        <Checkbox :label-text="t('alarm_listing.panel.scope_group')" value="group" v-model="selectedScope" />
      </div>
    </div>
    <p class="max-w-prose text-left text-sm font-medium leading-relaxed text-body">
      {{ t('alarm_listing.header.subtitle') }}
    </p>
  </div>
</template>
